import { createAction, props } from "@ngrx/store";
import { UserProfile } from "oidc-client-ts";

export const Login = createAction(
  "[AUTH] LOGIN",
  props<{ accessToken: string; expiresAt: number; profile: UserProfile; autoLogin: boolean }>()
);

export const Logout = createAction("[AUTH] LOGOUT");

export const TokenRefreshed = createAction(
  "[AUTH] TOKEN_REFRESHED",
  props<{ accessToken: string; expiresAt: number; profile: UserProfile }>()
);
